import type from './BOMConfig.type';

const initialState = {
  previousStates: null,
};

const previousConfig = (state = initialState, action) => {
  switch (action.type) {
    case type.SAVE_PREV_CONFIG:
      return {
        ...state,
        previousStates: action.payload,
      };

    default:
      return state;
  }
};

export default previousConfig;
